(function () {
    'use strict';

    var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
    
	$('#header .menu li a').on('mouseenter mouseleave', function() {
		$(this).parent().siblings().toggleClass('hover');
	});

})();